"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContentGuild;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _TabContentGuildModule = _interopRequireDefault(require("./TabContentGuild.module.scss"));

var _TabContentGuild = _interopRequireDefault(require("./TabContentGuild.i18n"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

var _assets = require("../../../../../../assets");

var _ColorizedImage = _interopRequireDefault(require("../../../../../common/ColorizedImage/ColorizedImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TabContentGuild(_ref) {
  var guild = _ref.guild,
      _ref$guildMemberType = _ref.guildMemberType,
      guildMemberType = _ref$guildMemberType === void 0 ? "MEMBER" : _ref$guildMemberType,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var renderGuildInfo = (0, _react.useCallback)(function () {
    if (!guild) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    var name = guild.name,
        guildmaster = guild.guildmaster,
        homeTown = guild.homeTown,
        iconFileName = guild.iconFileName,
        iconColor = guild.iconColor,
        cloakColor = guild.cloakColor,
        reputation = guild.reputation,
        rank = guild.rank,
        members = guild.members;
    var icon = "".concat(_assets.ASSETS_GUILD_MARKS, "/").concat(iconFileName);
    var masterName = guildmaster.name;
    var i18nHomeTownName = homeTown.i18nName;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.name
    }, name), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.attributes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.guildmaster
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.title
    }, formatMessage(_TabContentGuild.default.master)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.value
    }, masterName)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.hometown
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.title
    }, formatMessage(_TabContentGuild.default.hometown)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.value
    }, i18nHomeTownName[locale])), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.members
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.title
    }, formatMessage(_TabContentGuild.default.membersCount)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.value
    }, members.length)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.reputation
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.title
    }, formatMessage(_TabContentGuild.default.reputation)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.value
    }, reputation)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.rating
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.title
    }, formatMessage(_TabContentGuild.default.rating)), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.value
    }, rank))), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.guildmark,
      style: {
        backgroundColor: cloakColor
      }
    }, /*#__PURE__*/_react.default.createElement(_ColorizedImage.default, {
      imgSrc: icon,
      color: iconColor
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _TabContentGuildModule.default.buttons
    }, (guildMemberType === "MASTER" || guildMemberType === "VICEMASTER") && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.GUILD_BASE1_116X17,
      className: _TabContentGuildModule.default.button1
    }, formatMessage(_TabContentGuild.default.invite)), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.GUILD_BASE1_116X17,
      className: _TabContentGuildModule.default.button2
    }, formatMessage(_TabContentGuild.default.alliances))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.GUILD_BASE1_116X17,
      className: guildMemberType === "MASTER" || guildMemberType === "VICEMASTER" ? _TabContentGuildModule.default.button3 : _TabContentGuildModule.default.button1
    }, formatMessage(_TabContentGuild.default.members)), guildMemberType === "MEMBER" && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.GUILD_BASE1_116X17,
      className: _TabContentGuildModule.default.button2
    }, formatMessage(_TabContentGuild.default.leave)), guildMemberType === "MASTER" && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.GUILD_BASE1_116X17,
      className: _TabContentGuildModule.default.button4
    }, formatMessage(_TabContentGuild.default.dismiss))));
  }, [formatMessage, guild, guildMemberType, locale]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentGuildModule.default.content, _TabContentGuildModule.default[guildMemberType], className),
    style: style
  }, renderGuildInfo());
}